export { default as ComunicadosList } from './Listar';
export { default as ComunicadoCrear } from './Crear';
export { default as VerComunicado } from './Ver'
